module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"LogoutButton":{"text":"Odhlásit"}},"en":{"LogoutButton":{"text":"Log out"}}}')
  delete Component.options._Ctor
}
